<template>
 <div>
   <form v-on:submit.prevent="submitForm">
     <div class="drop-header">
       <div class="drop-title ">
         <h5>Set Times <span v-if="shiftTme" class="text-danger">({{shiftTme}} Hours)</span></h5>
         Flexible Time  <input type="checkbox" v-model="scheduleForm.is_floating_shift" :true-value="1" :false-value="0">
       </div>
       <a data-toggle="collapse" @click="closeModalBtn" class="close"
          :href="'#shift-dropdown-'+week+ keyIndex"
          role="button" aria-expanded="false"
          aria-controls="shift-dropdown">
         <span class="ico-cross"></span>
       </a>
     </div>
     <div class="drop-body">

       <div class="inputs-wrapper">
         <div class="inputs-holder">
           <div class="field-col">
             <label>Start Time <span class="text-danger">*</span></label>
             <input type="time" v-model="scheduleForm.start_time" @change="calculateShiftTime(day)" class="form-control"
                    value="06:00">
           </div>
           <div class="field-col">
             <label>End Time <span class="text-danger">*</span></label>
             <input type="time" v-model="scheduleForm.end_time"  @change="calculateShiftTime(day)" class="form-control" value="22:00">
             <span class="next-text text-danger" v-if="shiftEndTmeAlert" >Ending next day</span>
           </div>
           <div class="field-col">
             <label for="exampleFormControlSelect1">Break Time</label>
             <div class="nav-selectdrop">
               <select id="exampleFormControlSelect1" v-model="scheduleForm.break_time"
                       class="form-control  ">
                 <option selected="" value="">Select</option>
                 <option :value="20">20 Min</option>
                 <option :value="30">30 Min</option>
                 <option :value="40">40 Min</option>
                 <option :value="60">60 Min</option>
               </select>
             </div>
           </div>
         </div>

         <div class="inputs-holder " v-bind:class="{ 'job-roll': newJobRoleNameForm }">
           <div class="field-col ">
             <label for="job-role">Job Roles <span class="text-danger">*</span></label>
             <div class="nav-selectdrop">
               <select id="job-role" v-model="scheduleForm.job_role_id"
                       @change="getEmployeeByJobRoleChange($event)" class="form-control  text-capitalize">
                 <option value="">Select</option>
                 <option class="text-capitalize" v-if="jobTypes.length>0" v-for="value in jobTypes" :value="value.id">
                   {{ value.name }}
                 </option>
                 <option disabled="">-------------------</option>
                 <option disabled="">Missing a job role?</option>
                 <option class="mt-20 border-top" value="new">+Create new job role</option>
               </select>
               <div class="overlayer-input">

                 <input type="text" class="form-control  " v-model="new_job_role_name">

                 <button class="btn btn-outline-primary btn-save"
                         v-on:click="saveNewCompanyJobRole">Save
                 </button>
                 <button class="btn btn-outline-primary btn-cancel"
                         v-on:click="cancelNewCompanyJobRole">Cancel
                 </button>
               </div>
             </div>
             <p v-if="validity.job_role_id === 'invalid'" class="mt-5" :class="{textRed : validity.job_role_id === 'invalid'}">Select Job Role</p>
           </div>
           <div class="clearfix"></div>

           <div class="field-col">
             <label for="employee">Employee</label>
             <div class="nav-selectdrop">
               <select id="employee" v-model="scheduleForm.employee_id"
                       class="form-control text-capitalize ">
                 <option value="">Open Shift</option>
                 <option :value="jobTypesEmployees.adminDetail.employee.id" v-if="jobTypesEmployees.adminDetail">{{jobTypesEmployees.adminDetail.employee.name}}</option>
                 <option class="text-capitalize" v-if="jobTypesEmployees.employees.length>0 && value.employee.empRequest.length==''"
                         v-for="value in jobTypesEmployees.employees"
                         :value="value.employee.id">{{ value.employee.name }}
                 </option>
                 <option disabled=""  >-------------------</option>
                 <option disabled="" >Employees In Leave</option>
                 <option class="text-capitalize" v-if="jobTypesEmployees.employees.length>0 && value.employee.empRequest.length>0"
                         v-for="value in jobTypesEmployees.employees"
                         :value="value.employee.id">{{ value.employee.name }}
                 </option>
                 <option disabled=""></option>

               </select>

             </div>
           </div>
           <div class="field-col">
             <label>Note (optional)</label>
             <input type="text" v-model="scheduleForm.comment" class="form-control"
                    value="Add a Note ...">
           </div>
         </div>
         <div class="text-danger" v-text="new_job_role_name_error"></div>
       </div>
     </div>
   </form>
   <div class="drop-footer">
     <button class="btn btn-outline-primary btn-sm" @click="addAnotherShiftFun(day)">add another
       shift
     </button>
     <button @click="shiftSaveFunc(day)" class="btn btn-outline-primary btn-sm">Save
     </button>
   </div>
 </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import router from '../../../router/router'
import axios from "axios";
export default {
  name: 'jobRole',
  components: {},
  props:["roster_schedule_id","week","startWeek","endWeek","day","keyIndex","jobTypes"],
  data() {
    return{

      jobTypesEmployees:[],
      newJobRoleNameForm: false,
      new_job_role_name: '',
      new_job_role_name_error: '',
      company_id: this.$store.getters.getSelectedCompany.id,
      shiftTme:'',
      shiftEndTmeAlert:false,
      validity:{
        job_role_id:'',
        start_time:'',
        end_time:'',
      },
      scheduleForm: {
        is_floating_shift: '0',
        date: '',
        start_time: '10:00',
        end_time: '19:00',
        break_time: '60',
        job_role_id: '',
        employee_id: '',
        company_id: this.$store.getters.getSelectedCompany.id,
        comment: '',
      },
    }
  },
  created() {
    this.calculateShiftTime(this.day);
  },
  methods:{
    calculateShiftTime(date){
      this.shiftTme= this.calculateHourMinutes2( this.scheduleForm.start_time, this.scheduleForm.end_time,date);
      if(this.scheduleForm.start_time<this.scheduleForm.end_time){
        this.shiftEndTmeAlert=false;
      }else{
        this.shiftEndTmeAlert=true;
      }
    },
    getEmployeeByJobRoleId(id) {
      axios.get(this.$GetEmployeesByJobRolesType, {
        headers: this.getAuthHeader(),
        params: {
          job_role_id: id,
          date: this.day,
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.jobTypesEmployees = res.data.result;
          }
        });
    },
    closeModalBtn() {
      this.isModalVisible = false;
    },
    getEmployeeByJobRoleChange(event) {
      this.validateInput('job_role_id');
      if (event.target.value === 'new') {
        this.newJobRoleNameForm = true;
        return 1;
      } else {
        if(event.target.value !==''){
          this.jobTypesEmployees = [];
          axios.get(this.$GetEmployeesByJobRolesType, {
            headers: this.getAuthHeader(),
            params: {
              job_role_id: event.target.value,
              company_id: this.company_id,
              date: this.day,
            }
          })
            .then(res => {
              if (res.data.status == 200) {
                this.jobTypesEmployees= res.data.result;
              }
            });
        }
      }
    },
    saveNewCompanyJobRole() {
      if (this.new_job_role_name == '') {
        this.new_job_role_name_error = 'Job role is required';
      } else {
        this.new_job_role_name_error = '';
        axios.post(this.$JobRolesType,
          {
            company_id: this.company_id,
            name: this.new_job_role_name,
          }, {headers: this.getAuthHeader()})
          .then((res) => {
            if (res.status == 200) {
              this.new_job_role_name = '';
              this.scheduleForm.job_role_id = '';
              this.jobTypes.push({id:res.data.result.id,name:res.data.result.name});
              this.newJobRoleNameForm = false;
              $root.$toast.success(res.data.message);
            }
          });
      }
    },
    cancelNewCompanyJobRole() {
      this.new_job_role_name_error = '';
      this.scheduleForm.job_role_id = '';
      this.newJobRoleNameForm = false;
    },

    validateInput(fieldname = ''){
      if(fieldname == 'job_role_id' || fieldname == ''){
        if(this.scheduleForm.job_role_id === ''){
          this.validity.job_role_id = 'invalid'
        }else{
          this.validity.job_role_id = ''
        }
      }
      if(this.validity.job_role_id == ''){
        return true
      }else{
        return false
      }
    },
    addAnotherShiftFun(date) {
      if(this.validateInput()) {

        this.scheduleForm.date = date;
        if (this.scheduleForm.date == '') {
          return 1;
        }
        axios.post(this.$Schedules,
          {
            start_date: moment(this.startWeek).format('YYYY-MM-DD'),
            end_date: moment(this.endWeek).format('YYYY-MM-DD'),
            roster_schedule_id: this.roster_schedule_id,
            date: this.scheduleForm.date,
            start_time: this.scheduleForm.start_time,
            end_time: this.scheduleForm.end_time,
            break_time: this.scheduleForm.break_time,
            job_role_id: this.scheduleForm.job_role_id,
            employee_id: this.scheduleForm.employee_id,
            company_id: this.company_id,
            comment: this.scheduleForm.comment,
            is_floating_shift: this.scheduleForm.is_floating_shift,
          }, {headers: this.getAuthHeader()})
          .then((res) => {
            if (res.data.status == 200) {
              this.roster_schedule_id = res.data.result.roster_schedule_id;
              this.scheduleForm.comment = '';
              this.$router.push('/schedule/' + res.data.result.roster_schedule_id);
              this.$emit('shiftSaveMore', res.data.result.roster_schedule_id)
            }
          });
      }
    },

    shiftSaveFunc(date) {
      if(this.validateInput()) {
        this.scheduleForm.date = date;
        if (this.scheduleForm.date == '') {
          return 1;
        }
        axios.post(this.$Schedules,
          {
            start_date: moment(this.startWeek).format('YYYY-MM-DD'),
            end_date: moment(this.endWeek).format('YYYY-MM-DD'),
            roster_schedule_id: this.roster_schedule_id,
            date: this.scheduleForm.date,
            start_time: this.scheduleForm.start_time,
            end_time: this.scheduleForm.end_time,
            break_time: this.scheduleForm.break_time,
            job_role_id: this.scheduleForm.job_role_id,
            employee_id: this.scheduleForm.employee_id,
            company_id: this.company_id,
            comment: this.scheduleForm.comment,
            is_floating_shift: this.scheduleForm.is_floating_shift,

          }, {headers: this.getAuthHeader()})
          .then((res) => {
            if (res.data.status == 200) {
              this.roster_schedule_id = res.data.result.roster_schedule_id;
              this.isModalVisible = false;
              this.scheduleForm.job_role_id = '';
              this.jobTypesEmployees = [];
              this.$router.push('/schedule/' + this.roster_schedule_id);
              this.$emit('shiftSave', res.data.result.roster_schedule_id)
            }
          });
      }
    },

  }
}
</script>
<style scoped>

.shift-dropmenu .inputs-holder{
  align-items: flex-start;
}
.next-text{
  display: block;
  margin-top: 6px;
}
</style>
